"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon24Spinner", "spinner_24", "0 0 24 24", '<symbol fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="spinner_24"><path clip-rule="evenodd" d="M16.394 5.077A8.2 8.2 0 0 0 4.58 15.49a.9.9 0 0 1-1.628.767A10 10 0 1 1 12 22a.9.9 0 0 1 0-1.8 8.2 8.2 0 0 0 4.394-15.123z" fill="currentColor" fill-rule="evenodd" /></symbol>', 24, 24);
exports.default = _default;
